// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2Gfry","head":"ProcedureTableInfo_head__1AruN"};